import { apiClient } from "./httpClient";
import { unwrapEnvelope, unwrapList, unwrapMeta } from "./response";

export const inventoryApi = {
  async listProducts(params = {}) {
    const response = await apiClient.get("/inventory/products", { params });
    return {
      data: unwrapList(response.data),
      meta: unwrapMeta(response.data)
    };
  },

  async listMedicines(params = {}) {
    const response = await apiClient.get("/inventory/medicines", { params });
    return {
      data: unwrapList(response.data),
      meta: unwrapMeta(response.data)
    };
  },

  async createProduct(payload) {
    const response = await apiClient.post("/inventory/products", payload);
    return unwrapEnvelope(response.data, null);
  },

  async updateProduct(id, payload) {
    const response = await apiClient.put(`/inventory/products/${id}`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async countProducts(params = {}) {
    const response = await apiClient.get("/inventory/products/count", { params });
    return unwrapEnvelope(response.data, { count: 0 });
  },

  async createPurchase(payload) {
    const response = await apiClient.post("/inventory/purchases", payload);
    return unwrapEnvelope(response.data, null);
  },

  async addBatch(payload) {
    const response = await apiClient.post("/inventory/batch", payload);
    return unwrapEnvelope(response.data, null);
  },

  async receivePurchaseOrder(id, payload) {
    const response = await apiClient.post(`/inventory/purchase-orders/${id}/receive`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async deductStock(payload) {
    const response = await apiClient.post("/inventory/deductions", payload);
    return unwrapEnvelope(response.data, null);
  }
};
